"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _propTypes2 = _interopRequireDefault(require("../../../../constants/propTypes"));

var _alignmentTypes = _interopRequireDefault(require("../../../../constants/alignmentTypes"));

var _ContentCard = require("./ContentCard.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * The Content Card originated in the portal and is primarily for displaying larger chunks of information.
 * Padding has been increased, and on mobile the rounded corners get removed.
 */
var ContentCard = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(ContentCard, _React$PureComponent);

  var _super = _createSuper(ContentCard);

  function ContentCard() {
    _classCallCheck(this, ContentCard);

    return _super.apply(this, arguments);
  }

  _createClass(ContentCard, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          dataTestId = _this$props.dataTestId,
          textAlign = _this$props.textAlign;
      return /*#__PURE__*/_react.default.createElement(_ContentCard.StyledCard, {
        dataTestId: dataTestId,
        noBorder: true,
        withShadow: true,
        textAlign: textAlign
      }, /*#__PURE__*/_react.default.createElement(_ContentCard.ContentWrapper, null, children));
    }
  }]);

  return ContentCard;
}(_react.default.PureComponent);

_defineProperty(ContentCard, "propTypes", {
  /** Content */
  children: _propTypes2.default.children.isRequired,

  /** Test ID hook */
  dataTestId: _propTypes.default.string.isRequired,

  /** alignment of header and content */
  textAlign: _propTypes.default.oneOf(_alignmentTypes.default)
});

_defineProperty(ContentCard, "defaultProps", {
  textAlign: 'left'
});

var _default = ContentCard;
exports.default = _default;